import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { request } from '../..';
import { PATH } from '../../types';
export var path = function() {
    return "/retailers-pos-api/pos-locations";
};
export var build = function(options) {
    return _object_spread({
        route: route,
        url: path(),
        method: 'GET'
    }, options);
};
/**
 * path-to-regexp definition of this endpoint's route
 */ export var route = '/retailers-pos-api/pos-locations';
export function execute(options) {
    var _build = build(options), route = _build.route, requestOptions = _object_without_properties(_build, [
        "route"
    ]);
    return request(requestOptions);
}
execute[PATH] = 'retailers-pos-api/pos-locations/get';
export default execute;
